<template>
  <FlexLayout>
    <BlockContainer>
      <form @submit.stop.prevent>
        <Input
          v-if="!isTokenReset()"
          id="passwordOld"
          :label="$t('field.passwordOld')"
          type="password"
          v-model="$v.form.passwordOld.$model"
          :error="$v.form.passwordOld.$dirty && $v.form.passwordOld.$error ? $t('validation.fieldWarningRequired') : ''"
          :required="!isTokenReset()"
          autofocus
        />
        <Input
          id="passwordNew"
          :label="$t('field.passwordNew')"
          type="password"
          v-model="$v.form.passwordNew.$model"
          :error="$v.form.passwordNew.$dirty && $v.form.passwordNew.$error ? $t('validation.passwordPolicy') : ''"
          :required="true"
          autofocus
        />
        <Input
          id="passwordNewRepeat"
          :label="$t('field.passwordNewRepeat')"
          type="password"
          v-model="$v.form.passwordNewRepeat.$model"
          :error="$v.form.passwordNewRepeat.$dirty && $v.form.passwordNewRepeat.$error ? $t('validation.fieldWarningPasswordEqual') : ''"
          :required="true"
          autofocus
        />
      </form>
      <template #actions>
        <Button type="submit" @click="onSubmit" :disabled="$v.$invalid" variant="primary">{{$t('passwordReset.button.save')}}</Button>
      </template>
    </BlockContainer>
  </FlexLayout>
</template>
<script>
import { required, requiredIf, sameAs} from 'vuelidate/lib/validators'
import {accountService} from "../../../services/api/accountService";
import {useAppStore} from "@/stores/app";
import FlexLayout from "@/components/layout-components/Main/FlexLayout.vue";
import Input from "@/components/forms/Input.vue";
import BlockContainer from "@/components/layout/BlockContainer.vue";
import Button from "@/components/actions/Button.vue";

export default {
  data() {
    return {
      form: {
        passwordOld: undefined,
        passwordNew: undefined,
        passwordNewRepeat: undefined,
      },
      good: "",
      hidePasswordOld: true,
      hidePasswordNew: true,
      hidePasswordNewRepeat: true,
    }
  },
  computed: {
    config() {
      return window.config;
    },
  },
  components: {
    Button,
    BlockContainer,
    Input,
    FlexLayout,
  },
  setup() {
    const appStore = useAppStore();

    return {
      appStore,
    };
  },
  validations: {
    form: {
      passwordOld: {
        required: requiredIf(function() {
          // Nur required, wenn das Feld angezeigt wird
          return !this.isTokenReset();
        }),
      },
      passwordNew: {
        required: requiredIf(() => window.config.CUSTOMER_DATA.FIELDS.password.required),
        valid(value) {
          const containsUppercase = /[A-Z]/.test(value);
          const containsLowercase = /[a-z]/.test(value);
          const containsNumber = /[0-9]/.test(value);
          const containsSpecial = /[#?!@$%^&*-]/.test(value);
          const hasMinLength = value.length >= window.config.CUSTOMER_DATA.FIELDS.password.minLength;
          const hasMaxLength = value.length <= window.config.CUSTOMER_DATA.FIELDS.password.maxLength;
          return (
              containsUppercase &&
              containsLowercase &&
              containsNumber &&
              containsSpecial &&
              hasMinLength &&
              hasMaxLength
          );
        },
      },
      passwordNewRepeat: {
        required,
        sameAsPassword: sameAs('passwordNew')
      }
    },
  },
  methods: {
    showPasswordOld() {
      this.hidePasswordOld = !this.hidePasswordOld;
    },
    showPasswordNew() {
      this.hidePasswordNew = !this.hidePasswordNew;
    },
    async onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.makeToast('danger', this.$t('notification.fillAllRequiredFields'));
        return;
      }

      let result;
      if (this.isTokenReset())
      {
        const resetToken = this.$route.query.resetToken;
        result = await accountService.changePasswordWithToken(this.form.passwordNew, this.form.passwordNewRepeat, resetToken);
      } else {
        result = await accountService.changePassword(this.form.passwordOld, this.form.passwordNew, this.form.passwordNewRepeat);
      }
      if (result.errorCode < 0) {
        this.makeToast('danger', result.errorMsg);
        return;
      }

      if (result.exception != undefined) {
        this.makeToast('danger', this.$t('passwordReset.messages.error.onReset'));
        return;
      }

      this.appStore.setFlashToast({
        variant: 'success',
        message: this.$t('passwordReset.messages.info.onReset'),
      });
      this.$navigateToAccount(true);
    },
    isTokenReset()
    {
      return !!(this.$route && this.$route.query && this.$route.query.resetToken);
    },
  },
}

</script>

<style scoped>
  input[type="password"]::-ms-reveal {
    display: none;
  }
</style>
